import { HelpDropdown } from 'blaze-components/TopBar/HelpDropdown/HelpDropdown'
import { UserProfileAdd, Help, Lightning, Users, Templates, Gift01 } from 'blaze-ui/icons'
import {
  BottomItem,
  BottomItemExternalLink,
} from 'blaze-components/WorkspaceDashboardSidebar/components/BottomItem/BottomItem'
import { InviteTeamModal } from 'components/Growth/InviteTeamModal/InviteTeamModal'
import { useModals } from 'almanac-ui/Modal'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { observer } from 'mobx-react-lite'
import { useOpenIntegrations } from 'hooks/useOpenIntegrations'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { generatePath, useHistory } from 'react-router-dom'
import { TEMPLATES_PATH } from 'paths'
import CalendarPost from 'blaze-ui/icons/20/CalendarPost'
import { useOpenAutopilotUpgrade } from 'hooks/useOpenAutopilotUpgrade'
import { FreemiumUsageText } from 'components/AutopilotUpgradeButtons/FreemiumUsageText'
import { useIsAPFreemium } from 'hooks/useIsAPFreemium'
import { ReferralModalV2 } from 'components/Settings/ReferralModalV2/ReferralModalV2'
import { useIsIntegrationsV3 } from 'hooks/useIsIntegrationsV3'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'
import { useAPMobileWeb } from 'hooks/useAPMobileWeb'
import { AutopilotPlansModal } from 'components/Settings/Workspace/AutopilotPlans/AutopilotPlansModal'

export const AUTOPILOT_COMMUNITY_LINK =
  'https://community.blaze.ai/join?invitation_token=3d3365af96a4666fb91704734594ec7de35a0736-60ac922c-cccd-470d-a6d1-b0b6ab1ca942'
export const COPILOT_COMMUNITY_LINK =
  'https://community.blaze.ai/join?invitation_token=46588f4bb1747e85787e48f8db61f1bb9d8cf4a7-973c6674-206d-4196-b546-0b143684682d'

export const BottomItems = observer(() => {
  const { openModal } = useModals()
  const { isMobileMd } = useResponsiveDesign()
  const openIntegrations = useOpenIntegrations()
  const workspace = useCurrentWorkspace()
  const history = useHistory()
  const isAPFreemium = useIsAPFreemium()
  const openVirtualMarketerPlansModal = useOpenAutopilotUpgrade()
  const hideIntegrations = useIsIntegrationsV3()
  const isVirtualMarketer = useIsVirtualMarketer()

  const goToTemplates = () => {
    if (!workspace) return

    history.push(generatePath(TEMPLATES_PATH, { workspaceId: workspace.id }))
  }

  const communityLink = workspace?.is_virtual_marketer ? AUTOPILOT_COMMUNITY_LINK : COPILOT_COMMUNITY_LINK

  const guardedOpenInviteTeamModal = () => {
    if (!workspace?.is_virtual_marketer) {
      openModal(AutopilotPlansModal)
      return
    }

    openModal(InviteTeamModal, {})
  }

  const isAPMobileWeb = useAPMobileWeb()

  return (
    <>
      {/* ANY TIME YOU CHANGE ONE OF THESE, UPDATE useBottomItemsCount */}
      {isAPFreemium && !isAPMobileWeb && (
        <BottomItem icon={CalendarPost} onPress={() => openVirtualMarketerPlansModal()}>
          <FreemiumUsageText />
        </BottomItem>
      )}

      <BottomItem icon={Gift01} onPress={() => openModal(ReferralModalV2)}>
        Refer & Earn
      </BottomItem>

      <BottomItemExternalLink icon={Users} href={communityLink} target="_blank">
        Join our Community
      </BottomItemExternalLink>

      <BottomItem icon={UserProfileAdd} onPress={guardedOpenInviteTeamModal}>
        Invite Team Members
      </BottomItem>

      {!hideIntegrations && (
        <BottomItem
          icon={Lightning}
          onPress={() => {
            openIntegrations()
          }}
        >
          Integrations
        </BottomItem>
      )}
      {!isVirtualMarketer && (
        <BottomItem icon={Templates} onPress={() => goToTemplates()}>
          Templates
        </BottomItem>
      )}
      <HelpDropdown
        placement={isMobileMd ? 'top' : 'right-end'}
        trigger={<BottomItem icon={Help}>Help & Learn Blaze</BottomItem>}
      />
    </>
  )
})
